module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0